import fetch from 'cross-fetch'
import { phaserUtil } from '../../engine/phaserUtil-sidecar'
import { common } from '../../main/common-sidecar'
import { voyageTestParams } from './voyageTestParams-sidecar'

const namespace = 'voyage-json-server'
const filename = 'voyage'

export function save(data: any) {
  console.log(namespace, 'attempt to save', filename)
  fetch('//localhost:4500/put', {
    method: 'POST',
    body: JSON.stringify(
      {
        filename,
        data, //: JSON.stringify(data, null, 2),
      },
      null,
      2,
    ),
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then((res) => {})
    .catch((err) => {
      console.error(namespace, err)
    })
}

export function load() {
  console.log(namespace, 'attempt to load', filename)

  if (voyageTestParams.isDevMode) {
    fetch('//localhost:4500/get', {
      method: 'POST',
      body: JSON.stringify(
        {
          filename,
        },
        null,
        2,
      ),
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((res) => {
        console.log('loaded')
        res.json().then((res2) => {
          //console.log(res2)
        })
      })
      .catch((err) => {
        console.error(namespace, err)
      })
  } else {
  }
}

export async function loadAsync() {
  console.log(namespace, 'attempt to load', filename)

  try {
    if (voyageTestParams.isDevMode) {
      const res = await fetch('//localhost:4500/get', {
        method: 'POST',
        body: JSON.stringify(
          {
            filename,
          },
          null,
          2,
        ),
        headers: {
          'Content-Type': 'application/json',
        },
      })

      const json = await res.json()
      console.log(namespace, 'loaded')
      return json
    } else {
      console.log('get compiled json...')
      return common.getPhaserScene().cache.json.get('voyage')
    }
  } catch (err) {
    console.error(namespace, err)
  }
}
